import 'aos/dist/aos.css';
import AOS from 'aos';
import { useState, useEffect } from "react";
import PaymentApiService from '../../ApiServices/PaymentApiServices/PaymentApiService';
import { Banknote, CreditCard, Landmark, MapPin, User, Shield, Home, CheckCircle, Calendar, MoreHorizontal } from "lucide-react";

const PaymentDetailsTable = () => {
    const [data, setData] = useState([]);

    useEffect(() => {
        AOS.init({ duration: 1000, once: true });
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const paymentData = await PaymentApiService.Get();
            setData(paymentData.data || []); // Ensure it's an array
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    return (
        <div className="p-6 bg-gray-100 min-h-screen flex-grow">
            <div className="max-w-7xl mx-auto space-y-6">
                {/* Payment Details Table */}
                <div className="bg-white shadow-lg rounded-lg p-6">
                    <h3 className="text-lg font-semibold text-gray-900 mb-4">Bank Account Details</h3>
                    <div className="overflow-x-auto">
                        <table className="w-full border-collapse border border-gray-200">
                            <thead className="bg-gradient-to-r from-purple-600 to-pink-500 text-white">
                                <tr>
                                    {[
                                        { label: "Publisher", icon: User },
                                        { label: "Bank Account", icon: CreditCard },
                                        { label: "Bank Name", icon: Banknote },
                                        { label: "Branch", icon: Landmark },
                                        { label: "Owner", icon: User },
                                        { label: "Swift Code", icon: Shield },
                                        { label: "Address", icon: Home },
                                        { label: "Status", icon: CheckCircle },
                                        { label: "Created On", icon: Calendar },
                                    ].map(({ label, icon: Icon }) => (
                                        <th key={label} className="px-4 py-3 text-left text-sm font-semibold uppercase tracking-wider border-b border-gray-300">
                                            <Icon size={16} className="inline-block" /> {label}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {data.length > 0 ? (
                                    data.map((item) => (
                                        <tr key={item.id} className="text-gray-700 border-b hover:bg-gray-100 transition">
                                            <td className="px-4 py-3 border">{item.user.firstName + " " + item.user.lastName}</td>
                                            <td className="px-4 py-3 border">{item.bankAccountNumber}</td>
                                            <td className="px-4 py-3 border">{item.bankName}</td>
                                            <td className="px-4 py-3 border">{item.bankBranch}</td>
                                            <td className="px-4 py-3 border">{item.owner}</td>
                                            <td className="px-4 py-3 border">{item.swiftCode}</td>
                                            <td className="px-4 py-3 border">{item.address}</td>
                                            <td className="px-4 py-3 border">
                                                <span className={`px-2 py-1 text-xs font-semibold rounded-full ${item.isActive ? "bg-green-200 text-green-700" : "bg-red-200 text-red-700"}`}>
                                                    {item.isActive ? "Active" : "Inactive"}
                                                </span>
                                            </td>
                                            <td className="px-4 py-3 border">{new Date(item.createdOn).toLocaleDateString()}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="10" className="px-4 py-3 text-center text-gray-500">No payment details found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default PaymentDetailsTable;
